import { PartnerEndpoints } from '../../../utils/endpoints';
import PageHeader from '../../shell/PageHeader';
import LedgerTable from './sub-merchant/LedgerTable';

const SubMerchantLedger = () => (
  <>
    <PageHeader title="Ledger" breadcrumbs={[{ label: 'Home', to: '/layout' }, { label: 'Ledger' }]} />
    <p className="mb-6 text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
      Settled taps on your PANs are credited here when your partner settles through CashCard, and withdrawals to your
      bank account are debited. Taps from before a PAN was assigned to you are not credited, so the dashboard's volume
      will not always match this balance.
    </p>
    <LedgerTable endpoint={PartnerEndpoints.ownLedger} />
  </>
);

export default SubMerchantLedger;
